import React, { useEffect, useRef, useState } from 'react';
import { Box, Checkbox, FormControlLabel, Grid, InputLabel, MenuItem, Popover, Radio, RadioGroup, Select, TextField, Typography } from '@mui/material';
import _ from 'lodash';
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList } from "react-window";
import { ReactComponent as DropDownIcon, ReactComponent as IconAngleDown } from '../../assets/icons/icon-angle-down.svg';
import { isArrayEqual } from '../../utils/Reusables';
import Button from '../controls/Button';
import Controls from '../controls/Controls';
import { Form, useForm } from "../useForm";
import toast from 'react-hot-toast';

const initialFValues = {
  index: -1,
  displayName: '',
  valuesList: []
}

export default function FormatControl(props) {
  const { addOrEdit, recordForEdit, reportDetails, updateReportDetails, mode, measureList } = props
  const [specificValue, setSpecificValue] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [listType, setListType] = useState('dropdown');
  const [showRelevantGrid, setShowRelevantGrid] = useState(false)
  const [dynamicLabel, setDynamicLabel] = useState(false);
  const [addToReportType, setAddToReportType] = useState(null);
  const [dateRangeType, setDateRangeType] = useState("");
  const [dateRangeTypeDropdownStatus, setDateRangeTypeDropdownStatus] = useState(false);

  const [timePeriodFilterData, setTimePeriodFilterData] = useState([]);
  const [selectedTimPeriodData, setSelectedTimPeriodData] = useState([]);
  const [timePeriodValue, setTimePeriodValue] = useState(null);

  const [filterInputEl, setFilterInputEl] = React.useState(null);
  const [filterInputOpen, setFilterInputOpen] = React.useState(false);
  const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
  const [defaultDateType, setDefaultDateType] = useState(null)
  const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
  const selectFiltersInput = useRef(null);
  useEffect(() => {
    setTimePeriodFilterData([
      'Today',
      'Yesterday',
      'This Week',
      'Last Week',
      'This Month',
      'Last Month',
      'This Quarter',
      'Last Quarter',
      'This Year',
      'Last Year',
      'Custom'
    ])

    if (recordForEdit && recordForEdit?.dateFilterProps && recordForEdit?.dateFilterProps?.dateSelectType) {
      setDefaultDateType(recordForEdit?.dateFilterProps?.dateSelectType);
    }

    if (recordForEdit && recordForEdit?.dateFilterProps && recordForEdit?.dateFilterProps?.dateSelectType === 'TIME_PERIOD') {
      if (recordForEdit?.dateFilterProps?.timePeriod?.length > 0) {
        setSelectedTimPeriodData(recordForEdit?.dateFilterProps?.timePeriod);
        handleTimePeriodUpdate(recordForEdit?.dateFilterProps?.timePeriod);
        setAddToReportType(recordForEdit?.dateFilterProps?.dateSelectType)
        setDateRangeType(recordForEdit?.dateFilterProps?.dateRangeType)
      }
    }

    if (recordForEdit?.dateFilterProps?.dateSelectType) {
      setAddToReportType(recordForEdit?.dateFilterProps?.dateSelectType)
    }

    if (recordForEdit && recordForEdit?.dateFilterProps && recordForEdit?.dateFilterProps?.dateSelectType === 'DATE_RANGE') {
      if (recordForEdit?.dateFilterProps?.dateRangeType) {
        setDateRangeType(recordForEdit?.dateFilterProps?.dateRangeType);
      }
    }

  }, []);

  const handleFilterInputClose = (e, type) => {
    if (e) e?.stopPropagation();
    setFilterInputEl(null);
    setFilterInputOpen(false);

  };

  const handleSelectAllTimePeriodUpdate = () => {
    let clonedSubjectsArray = _.clone(timePeriodFilterData)
    setSelectedTimPeriodData(clonedSubjectsArray)
  }

  const handleFilterInputClick = (event) => {

    setSelectFilterWidth(selectFiltersInput.current.clientWidth);
    if (event.currentTarget != filterInputEl) setFilterInputEl(event.currentTarget);
    if (!filterInputOpen) setFilterInputOpen(true);
  };

  const MultiSelectRow = ({ index, style, data }) => {
    const item = data[index];
    return <div style={style} key={item}>
      <FormControlLabel title={item} className="menu-item menu-item-light" label={item}
        control={<Checkbox className="form_checkbox" size="small"
          checked={selectedTimPeriodData.indexOf(item) > -1}
          value={item}
          onChange={handleTimePeriodFilterChange} />} />
    </div>
  }

  const handleUnSelectAllTimePeriodData = () => {
    setSelectedTimPeriodData([])
    setTimePeriodValue(null)
  }

  const handleTimePeriodFilterChange = (e) => {
    const value = e?.target?.value
    const exist = selectedTimPeriodData.find(ele => ele === value)
    if (exist) {
      let newSelected = selectedTimPeriodData.filter(ele => ele !== value)

      setSelectedTimPeriodData(newSelected)
    }
    else {
      let newSelected = [...selectedTimPeriodData]
      newSelected.push(value)
      setSelectedTimPeriodData(newSelected)
    }

  }

  const validate = (fieldValues = values) => {
    let temp = { ...errors }
    if ('displayName' in fieldValues) {
      temp.displayName = fieldValues.displayName ? "" : "Display Name is required."
    }

    setErrors({
      ...temp
    })

    if (fieldValues === values)
      return Object.values(temp).every(x => x === "")
  }

  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm
  } = useForm(initialFValues, true, validate);

  const handleInputChangeListType = (event) => {
    setListType(event.target.value);
  }
  const handleChangeOnSelectALl = (event) => {
    setSelectAll(event.target.checked);
  }

  const handleChangeOnSpecificValue = (event) => {
    setSpecificValue(event.target.checked);
  }

  const handleChangeDynamicLabel = (event) => {
    setDynamicLabel(event.target.checked)
  }

  const handleSubmit = e => {
    e.preventDefault();
    if (validate()) {
      values.specificValue = specificValue;
      values.selectAll = selectAll;
      values.listType = listType;
      values.useRelevant = recordForEdit?.useRelevant;
      values.relevantTo = recordForEdit?.relevantTo
      values.dynamicLabel = recordForEdit?.dynamicLabel
      if (recordForEdit?.type === 'time' && addToReportType === 'DATE_RANGE' && !dateRangeType) {
        toast.error('Date Range Type is required!');
        return
      }
      else if (recordForEdit?.type === 'time' && addToReportType === 'TIME_PERIOD' && !selectedTimPeriodData?.length) {
        toast.error('Time Period is required!');
        return
      }
      if (recordForEdit?.type === 'time') {
        values.dateFilterProps = {
          dateSelectType: addToReportType,
          dateRangeType: dateRangeType,  //date / dataTime
          timePeriod: selectedTimPeriodData,
          selectedTimePeriod: ""
        }

      }
      addOrEdit(values, resetForm);
    }
  }

  useEffect(() => {
    if (recordForEdit != null)
      setValues({
        ...recordForEdit
      })
  }, [recordForEdit, setValues])

  const showRelevantFilterValues = (e) => {
    e.stopPropagation();
    let isShow = showRelevantGrid;
    isShow = !isShow;
    setShowRelevantGrid(isShow)
  }

  const handleRelevantSelect = (e) => {

    const member = e?.target?.value;

    if (recordForEdit?.relevantTo && recordForEdit?.relevantTo !== member) {
      const previousRelevant = reportDetails?.reportDetails?.reportFilters.find(filter => filter?.member === recordForEdit?.relevantTo);

      previousRelevant.useRelevant = previousRelevant.useRelevant.filter(ele => ele?.relevantMember !== recordForEdit?.member)
      previousRelevant.valuesList = []

      const selectedFilter = reportDetails?.reportDetails?.reportFilters.find(filter => filter?.member === member)

      if (selectedFilter?.useRelevant) {
        const exist = selectedFilter?.useRelevant.find(member => member && member?.relevantMember === recordForEdit?.member)

        if (!exist) {
          selectedFilter.useRelevant.push({ relevantMember: recordForEdit?.member })
        }
      }
      else {
        selectedFilter.useRelevant = []
        selectedFilter.useRelevant.push({ relevantMember: recordForEdit?.member })
      }

      recordForEdit.relevantTo = member
    }
    else if (!recordForEdit?.relevantTo) {

      const selectedFilter = reportDetails?.reportDetails?.reportFilters.find(filter => filter?.member === member)

      if (!selectedFilter?.useRelevant) {
        selectedFilter.useRelevant = []
      }
      const exist = selectedFilter?.useRelevant.find(member => member && member?.relevantMember === recordForEdit?.member)

      if (!exist) {
        selectedFilter.useRelevant.push({ relevantMember: recordForEdit?.member })
      }
      recordForEdit.relevantTo = member
    }


    updateReportDetails({ reportDetails: reportDetails.reportDetails })

  }

  const handleSelectDynamicLabel = (e) => {
    const value = e?.target?.value
    const measure = measureList.find(meas => meas?.name === value)
    recordForEdit.dynamicLabel = {
      label: `${recordForEdit?.member.split('.')[0]}.${value}`,
      dataSetType: measure?.dataSetType
    }
    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  const generateDynamicLabelOptions = () => {
    if (measureList && measureList?.length) {
      return measureList?.map(meas => {
        if ((meas?.type !== 'time')) {
          return (<MenuItem className='menu-item' value={meas?.name}>
            {meas?.name}
          </MenuItem>)
        }
      })
    }
  }

  const handleRemoveCascadeFilter = () => {

    if (recordForEdit?.relevantTo) {
      const parentFilter = reportDetails?.reportDetails?.reportFilters.find(filter => filter?.member === recordForEdit?.relevantTo);

      parentFilter.useRelevant = parentFilter.useRelevant.filter(ele => ele?.relevantMember !== recordForEdit?.member)

      if (recordForEdit?.useRelevant && recordForEdit?.useRelevant?.length) {
        for (let rel of recordForEdit?.useRelevant) {
          const { relevantMember } = rel
          const childFilter = reportDetails?.reportDetails?.reportFilters.find(filter => filter?.member === relevantMember)
          childFilter.relevantTo = '';
        }
      }
    }

    recordForEdit.useRelevant = []
    recordForEdit.relevantTo = ''

    updateReportDetails({ reportDetails: reportDetails.reportDetails })
  }

  useEffect(() => {
    if (recordForEdit != null) {
      setSpecificValue(recordForEdit.specificValue);
      setListType(recordForEdit.listType || 'dropdown');
      setSelectAll(recordForEdit.selectAll);
      setDynamicLabel(recordForEdit?.dynamicLabel ? true : false)
    }
  }, [recordForEdit])

  const handleAddToReportTypeUpdate = (e) => {
    setAddToReportType(e.target.value);
    setDefaultDateType(e.target.value);
  }

  const handleDateRangeTypeUpdate = (e) => {
    setDateRangeType(e.target.value);
  }

  const handleTimePeriodUpdate = (timePeriodDataValue = null) => {
    var data;
    if (timePeriodDataValue) {
      data = timePeriodDataValue;
    } else {
      data = selectedTimPeriodData;
    }
    if (data.length > 0) {
      if (data.length <= 3) {
        setTimePeriodValue(data.join(','));
      } else {
        let selectedTimPeriodData_first = data.slice(0, 3);
        let val = selectedTimPeriodData_first.join(',') + "...(+" + (data.length - 3) + ")";
        setTimePeriodValue(val);
      }
    } else {
      setTimePeriodValue(null);
    }

    setFilterInputOpen(false);
    setFilterInputEl(null);

  }

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container className="width-100">
        <Grid item xs={12} sx={{ m: 0 }}>
          {
            props.labelType === 'outside' ?
              <InputLabel className="text-small label">Display Name</InputLabel>
              : null
          }

          <Controls.Input
            className={`report_form_ui_input width-100 m-0 ` + (values.displayName ? 'has-value' : ``)}
            name="displayName"
            value={values.displayName || ''}
            onChange={handleInputChange}
            error={errors.displayName}
            placeholder={(props.labelType == "placeholder") ? "Display Name" : null}
          />
        </Grid>

        {
          (recordForEdit.type === 'time' && (recordForEdit.operator === 'inDateRange' || recordForEdit.operator === 'notInDateRange')) ?
            <Grid item xs={12} sx={{ my: 2 }}>
              <RadioGroup
                row
                aria-labelledby="addToReportType"
                name="addToReportType-group"
                className='form-radio-group'
                onChange={(e) => handleAddToReportTypeUpdate(e)}
              >
                <FormControlLabel className="mr-2" value="TIME_PERIOD" control={<Radio checked={(defaultDateType === 'TIME_PERIOD') ? true : false} />} label="Time period" />
                <FormControlLabel value="DATE_RANGE" control={<Radio checked={(defaultDateType === 'DATE_RANGE') ? true : false} />} label="Date Range" />
              </RadioGroup>

            </Grid>

            : null
        }

        {
          (recordForEdit.type === 'time' && (recordForEdit.operator === 'inDateRange' || recordForEdit.operator === 'notInDateRange') && addToReportType === 'TIME_PERIOD' || (props.action === 'edit' && defaultDateType === 'TIME_PERIOD')) ?
            <>
              <Box className={`select_filters_input modal-filters-select ` + (filterInputOpen ? `has-expanded ` : ` `) + (selectedTimPeriodData.length ? `has-value` : ``)} onClick={handleFilterInputClick} ref={selectFiltersInput} >
                <Box style={{ overflow: 'hidden' }} className="select_filters_input_item" display="flex" alignItems="center">
                  <Typography className='modal-filters-select-label' variant='subtitle'>{timePeriodValue ?? `Select Time Period`}</Typography>
                </Box>
                <Box className="select_filters_input_item"><DropDownIcon /></Box>
              </Box>
              <Popover
                id={filterInputId}
                open={filterInputOpen}
                anchorEl={filterInputEl}
                onClose={e => handleFilterInputClose(e)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                PaperProps={{ classes: { root: 'filter-item-options' } }}
                disabled={false}
              >
                <Box className="filters-dropdown-item" sx={{ width: selectFilterWidth }}>

                  {timePeriodFilterData?.length ?
                    <Box className="filters-dropdown-item-content">
                      <FormControlLabel className="menu-item menu-item-light select-all-option" label="Select All"
                        control={<Checkbox className="form_checkbox" size="small" checked={isArrayEqual(timePeriodFilterData, selectedTimPeriodData)} onChange={handleSelectAllTimePeriodUpdate} />} />
                      <div className={`virtual-filter-div filter-addtoreport ` + ((timePeriodFilterData.length) ? 'filter-data-exists' : ``)}>
                        <AutoSizer>
                          {({ height, width }) => (
                            <FixedSizeList
                              className="List"
                              height={timePeriodFilterData?.length ? height : 20}
                              itemCount={timePeriodFilterData?.length}
                              width={width - 6}
                              itemData={timePeriodFilterData}
                              itemSize={35}
                            >
                              {MultiSelectRow}
                            </FixedSizeList>
                          )}
                        </AutoSizer>
                      </div>
                    </Box> :
                    <Box alignItems="center" justifyContent="center" className="select_filters_input_item">
                      <Typography className="filters-dropdown-item-label" >No Data</Typography>
                    </Box>}

                  <Box className="filters-dropdown-item-footer">
                    <Button sx={{ mr: 2 }} className="report_form_ui_btn cancel cancel2" variant='outlined' onClick={handleUnSelectAllTimePeriodData} disabled={selectedTimPeriodData?.length < 1} text="Clear All" />
                    <Button className="report_form_ui_btn submit" variant="contained" text="Apply" onClick={() => handleTimePeriodUpdate()} />
                  </Box>
                </Box>
              </Popover>
            </>

            : (recordForEdit.type === 'time' && (addToReportType === 'DATE_RANGE' || defaultDateType === 'DATE_RANGE')) ?
              <>
                <Grid item xs={12} sx={{ mb: 2 }}>
                  <Select
                    className={`report_form_ui_input_select ` + (dateRangeTypeDropdownStatus ? `is-open ` : ` `) + (dateRangeType ? `has-value ` : ` `)}
                    name="dateRangeType"
                    value={dateRangeType}
                    onChange={handleDateRangeTypeUpdate}
                    IconComponent={IconAngleDown}
                    displayEmpty
                    renderValue={dateRangeType !== "" ? undefined : () => <span className="form_select_placeholder">Select Date Range</span>}
                    onClose={() => setDateRangeTypeDropdownStatus(false)}
                    onOpen={() => setDateRangeTypeDropdownStatus(true)}

                  >
                    <MenuItem className='menu-item' value={"date"}>Date Only</MenuItem>
                    <MenuItem className='menu-item' value={"dateTime"}>Date & Time</MenuItem>

                  </Select>
                </Grid>

              </>

              : null
        }

        {recordForEdit.type === 'time' ? null :
          <>
            <Grid item xs={12} sx={{ my: 1 }}>
              <InputLabel className="text-small label">List Type</InputLabel>
              <Select
                className="report_form_ui_input_select pl-0 text-small"
                name="listType"
                value={listType}
                onChange={handleInputChangeListType}
                IconComponent={IconAngleDown}
                defaultValue=""
              >
                {(recordForEdit.type !== 'number' && recordForEdit.type !== 'count') &&
                  <MenuItem className='menu-item text-small' value={"dropdown"}>Dropdown</MenuItem>
                }
                {(recordForEdit.type !== 'number' && recordForEdit.type !== 'count') &&
                  <MenuItem className='menu-item text-small' value={"multipleselect"}>Multiple Select</MenuItem>
                }

                <MenuItem className='menu-item text-small' value={"inputValue"}>Input Value</MenuItem>
              </Select>
            </Grid>

            {(recordForEdit.type !== 'number' && recordForEdit.type !== 'count') &&
              <Grid item xs={12} >
                <FormControlLabel
                  className="text-small"
                  checked={!!selectAll}
                  label="Show Select All option"
                  control={<Checkbox className="form_checkbox" size="small" onChange={handleChangeOnSelectALl} />}
                />
              </Grid>
            }

            <Grid item xs={12}>
              <FormControlLabel
                className="text-small"
                checked={!!specificValue}
                label="Specific Value"
                control={<Checkbox className="form_checkbox" size="small" onChange={handleChangeOnSpecificValue} />}
              />
            </Grid>

            {mode !== 'addToReport' &&
              <Grid item xs={12}>
                <FormControlLabel
                  className="text-small"
                  checked={!!dynamicLabel}
                  label="Dynamic Label"
                  control={<Checkbox className="form_checkbox" size="small" onChange={handleChangeDynamicLabel} />}
                />
              </Grid>

            }

            <Grid sx={{ mt: 2 }} item xs={12} display={dynamicLabel ? "block" : "none"}>
              <InputLabel className="text-small label">Select Field</InputLabel>
              <Select
                className="report_form_ui_input_select pl-0"
                name="listType"
                value={recordForEdit?.dynamicLabel?.label && recordForEdit?.dynamicLabel?.label.split('.')[1]}
                onChange={handleSelectDynamicLabel}
                IconComponent={IconAngleDown}
                defaultValue=""
              >
                {
                  generateDynamicLabelOptions()
                }
              </Select>
            </Grid>



            <Grid sx={{ mt: 2 }} item xs={12} display={specificValue ? "block" : "none"}>
              <InputLabel className="text-small label">Value List</InputLabel>
              <TextField
                className="report_form_ui_input text-small"
                name="valuesList"
                multiline
                maxRows={4}
                value={values.valuesList || ''}
                onChange={handleInputChange}
                variant="outlined"
              />
            </Grid>

            {mode !== 'addToReport' &&
              <Grid item xs={12} sx={{ my: 1 }} onClick={showRelevantFilterValues}>
                <Controls.Button className="report_form_ui_btn cancel" variant="outlined" type="button" text="Show Relevant Values Only" />
              </Grid>

            }

            {(showRelevantGrid || recordForEdit?.relevantTo) && <Grid item xs={12} sx={{ my: 1 }}>
              <InputLabel className="text-small label">Select Filter</InputLabel>
              <Select
                className="report_form_ui_input_select pl-0"
                name="listType"
                value={recordForEdit?.relevantTo}
                onChange={handleRelevantSelect}
                IconComponent={IconAngleDown}
                defaultValue=""
              >
                {
                  reportDetails?.reportDetails?.reportFilters?.map(filter => {
                    return filter?.member !== recordForEdit?.member && recordForEdit?.type !== 'time' && (
                      <MenuItem className='menu-item' value={filter?.member}>
                        {filter?.displayName || (filter?.member).split('.')[1]}</MenuItem>
                    )
                  })
                }
              </Select>
              <Box className="filters-dropdown-item-footer">
                <Controls.Button className="report_form_ui_btn cancel mr-2" color="secondary" text="Remove" onClick={handleRemoveCascadeFilter} />
              </Box>
            </Grid>
            }
          </>
        }

        <Grid item xs={12}>
          <Box sx={{ mt: 2 }} display="flex" justifyContent={(props.alignType === 'center') ? 'center' : 'flex-end'}>
            <Controls.Button className="report_form_ui_btn cancel cancel2 mr-2" color="secondary" text="Reset" onClick={resetForm} />
            <Controls.Button className="report_form_ui_btn submit submit2" type="submit" text="Add" />
          </Box>
        </Grid>
      </Grid>
    </Form>
  )
}